export const storage_options = [
  {label: 'Frozen', value: 'frozen'},
  {label: 'Chilled', value: 'chilled'},
  {label: 'Ambient', value: 'ambient'},
]
